import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  /**
   * The page title as string
   */
  @Input() pageTitle: string;

  @Input()
  public showLoadingSpinner = false;
}
